import styled from 'styled-components';
import { COLORS } from '../../../constants/radar';

// Mirrors DirectManagerDiscrepancies/styles: bare filter row with a divider,
// white table card, soft chips.
export const FilterBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 16px;
`;

export const TableWrapper = styled.div`
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
`;

export const CandidateRow = styled.tr`
  &:hover {
    background-color: #fafafa;
  }
`;

// Person cell — same shape as the Bench Report row header (avatar + name link + detail lines).
export const PersonCell = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 260px;
`;

export const PersonInfo = styled.div`
  flex: 1;
  min-width: 0;

  .name {
    font-size: 14px;
    font-weight: 500;
    color: ${COLORS.PRIMARY};
  }

  .name-link {
    display: inline-block;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
      text-underline-offset: 2px;
    }
  }

  .detail {
    font-size: 12px;
    color: #64748B;
    margin-top: 2px;
  }

  .detail-left {
    color: #92400E;
  }
`;

export const Primary = styled.div`
  font-weight: 500;
  color: ${COLORS.PRIMARY};
`;

export const Secondary = styled.div`
  font-size: 12px;
  color: ${COLORS.SECONDARY};
`;

export const ReasonList = styled.ul`
  margin: 4px 0 0;
  padding-left: 18px;
  font-size: 12px;
  color: ${COLORS.SECONDARY};
`;

export const LoadMoreButton = styled.button`
  margin: 16px auto 0;
  display: flex;
  align-items: center;
  padding: 8px 20px;
  background: white;
  color: ${COLORS.PRIMARY};
  border: 1px solid ${COLORS.PRIMARY};
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;

  &:hover:not(:disabled) {
    background: ${COLORS.PRIMARY};
    color: white;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

// Same sort toggle as BenchEntryLagReport: results count on the left, sort fields on the right.
export const SortRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`;

export const SortButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #64748B;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s;

  &:hover {
    background-color: #f1f5f9;
    color: ${COLORS.PRIMARY};
  }

  svg {
    font-size: 12px;
  }
`;

// Header right side: last-run stats (Bench Data Entry Lag style) + the Refresh button.
export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  justify-content: flex-end;
`;
